import { useMemo } from 'react';
import { object, ObjectSchema, string } from 'yup';
import { addressWithCountrySchema } from '../../shared';
import { useSupporteeSchema } from './supportee.validator';
import { useContactsSchema } from './contacts.validator';
import { useTranslation } from 'react-i18next';
import { ISupportCaseForm } from '../models';

export function useSupportCaseSchema(): ObjectSchema<ISupportCaseForm> {
    const { t } = useTranslation();
    const supporteeSchema = useSupporteeSchema();
    const contactsSchema = useContactsSchema();

    return useMemo(
        () =>
            object().shape({
                primarySupportee: supporteeSchema.required(),
                contacts: contactsSchema.required(),
                address: addressWithCountrySchema(t).optional(),
                livingSituation: string().optional(),
                familySituation: string().optional(),
            }),
        [supporteeSchema, contactsSchema, t],
    );
}
